export default __webpack_public_path__ + "assets/images/started.2f1a9b.webp";